<script>
export default {
    name: "regionForm",
    props: {
        rowData: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    data() {
        return {
            submitLoading: false,
            ruleForm: {},
            rules: {
                maxOrderCount: [
                    { required: true, message: "请输入接单总数", trigger: "blur" },
                ],
                maxCrossCityCount: [
                    { required: true, message: "请输入跨城订单数", trigger: "blur" },
                    {
                        validator: (rule, value, callback) => { 
                            if (Number(value) > Number(this.ruleForm.maxOrderCount)) {
                                callback(new Error('不可大于接单总数'));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'blur'
                    }
                ],
            },
            disabled: true,
            oldData: {}
        };
    },

    watch: {
        rowData: {
            handler(newVal) {
                if (!newVal) return
                this.ruleForm = {
                    ...newVal,
                };
                this.oldData = {...this.ruleForm}
            },
        },
    },
    methods: {
        sure() {
            this.$refs.ruleForm.validate(async (valid) => {
                if (valid) {
                    this.submitLoading = true;
                    let params = this.$utils.deepCopyFn(this.ruleForm);
                    let url = ''
                    let res = {}
                    if(params.id){
                        url = "/api/v1/manage/hitchRideRegionRule/update";
                        res = await this.$axios.put(url, params);
                    }else{
                        url = "/api/v1/manage/hitchRideRegionRule/save";
                        res = await this.$axios.post(url, params);
                    }
                    
                    if (res.code === 1) {
                        this.$message.success("保存成功");
                        this.disabled = true;
                        this.$emit('refresh')
                    }
                    this.submitLoading = false;
                }
            });
        },
        handClose() {
            this.disabled = true;
            this.ruleForm = {...this.oldData}
        },
    },
};
</script>
<template>
    <div class="regionForm">
        <div class="flex-between">
            <div class="formTitle">每日接单限制</div>
            <el-button type="primary" v-if="disabled" @click="disabled = false">编辑</el-button>
            <div v-else>
                <el-button @click="handClose">取消</el-button>
                <el-button type="primary" @click="sure" :loading="submitLoading">保存</el-button>
            </div>
        </div>
        <div class="blueInfo flex">
            <i class="el-icon-warning" style="color: #409EFF;font-size: 16px; margin-right: 8px;"></i>
            <span>接单时，系统将根据以下配置，限制触发区域规则的司机抢单</span>
        </div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" label-position="left" :disabled="disabled">
            <el-form-item label="接单总数" prop="maxOrderCount">
                    <el-input v-model="ruleForm.maxOrderCount" v-input-filter="{ min: 2, max: 30, precision: 0 }">
                        <template slot="prepend">每日最多可接</template>
                        <template slot="append">单</template>
                    </el-input>
                </el-form-item>
                <el-form-item label=" 跨城订单" prop="maxCrossCityCount">
                    <el-input v-model="ruleForm.maxCrossCityCount" v-input-filter="{ min: 2, max: 30, precision: 0 }">
                        <template slot="prepend">每日最多可接</template>
                        <template slot="append">单</template>
                    </el-input>
                </el-form-item>
        </el-form>
    </div>
</template>


<style scoped lang="less">
.regionForm {
    width: 700px;
    /deep/ .el-input-group__append,
    .el-input-group__prepend {
        background-color: #F5F7FA !important;
    }
}
</style>